import { DATETIME_FORMATS } from '@constants/datetimeFormats';

export const getDateTimeFormat = (datetimeFormat) => {
  const { common, us } = DATETIME_FORMATS;
  return datetimeFormat === common.dateTime
    ? { date: common.date, time: common.time }
    : { date: us.date, time: us.time };
};
